module.exports = __webpack_public_path__ + "img/score_D.7091326b.png";